import { useRef, useState, useEffect } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { Prarthana, PurposePrarthana } from '@/globalTypes';
import IconButton from '@mui/material/IconButton';
import Slider from '@mui/material/Slider/Slider';
import { Skeleton } from '@mui/material';


const AudioPlayer = ({ src, updateCurrentPrarthana, prarthanaDetails, type }: { src: string, updateCurrentPrarthana: any, prarthanaDetails: Prarthana | PurposePrarthana, type: string }) => {
    const audioRef = useRef<any>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(1);
    const volumeAtMute = useRef<any>(1);
    const [showVolumeSlider, setShowVolumeSlider] = useState(false);

    useEffect(() => {
        const audio = audioRef.current;
        if (!audio) return;

        audio.addEventListener('timeupdate', updateTime);
        audio.addEventListener('loadedmetadata', updateDuration);

        return () => {
            audio.removeEventListener('timeupdate', updateTime);
            audio.removeEventListener('loadedmetadata', updateDuration);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioRef.current]);

    useEffect(() => {
        if (currentTime === duration && audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.pause();
            setIsPlaying(false);
        }
    }, [currentTime, duration]);
    const updateTime = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const updateDuration = () => {
        setDuration(audioRef.current.duration);
    };

    const handleVolumeChange = (event: any, newValue: any) => {
        const audio = audioRef.current;
        setVolume(newValue);
        audio.volume = newValue;
        if (newValue === 0) {
            handleMuteBotton();
        }
        if (newValue && audioRef.current.muted) {
            handleMuteBotton();
        }
    };

    const formatTime = (time: number) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = Math.floor(time % 60);
        return `${hours > 0 ? `${hours}:` : ''}${minutes < 10 ? `0${minutes}:` : `${minutes}:`}${seconds < 10 ? `0${seconds}` : seconds}`;
    };
    const handleMuteBotton = () => {
        if (!audioRef.current.muted) {
            audioRef.current.muted = true;
            volumeAtMute.current = volume;
            setVolume(0);
        } else {
            audioRef.current.muted = false;
            setVolume(volumeAtMute.current);
        }
    }


    return (
        <>
            <div className={`audio-player flex items-center gap-[12px] p-[4px] ${isPlaying ? "bg-[#E9B82433]" : `${type === "prarthana"?'bg-[#FFFFFF]':'bg-[#ede4dd]'}`} rounded-[6px] ${isPlaying ? "border" : ""}`} >
                <audio ref={audioRef} src={src} controls={false} />

                {duration ? <div>
                    <IconButton className={`relative group `}>
                        {isPlaying ? (
                            <PauseIcon sx={{ color: '#EE9322' }} onClick={() => { updateCurrentPrarthana(audioRef.current, "pause", prarthanaDetails, setIsPlaying) }} />
                        ) : (
                            <PlayArrowIcon sx={{ color: '#000000' }} onClick={() => { updateCurrentPrarthana(audioRef.current, "play", prarthanaDetails, setIsPlaying) }} />
                        )}
                    </IconButton>
                </div> : <Skeleton variant='circular' height={'40px'} width={'40px'} animation="wave"></Skeleton>}

                <div className="timer text-sm">
                    {duration ? `${formatTime(currentTime)} / ${formatTime(duration)}` : <Skeleton variant='rounded' height={'20px'} width={'80px'} animation="wave"></Skeleton>}
                </div>

                <div className="relative flex-grow">
                    <div className="w-full h-1 bg-gray-300 rounded-full overflow-hidden cursor-pointer relative">
                        <div
                            className={`h-full ${isPlaying ? 'bg-[#EE9322]' : 'bg-[#00000038]'} `}
                            style={{ width: `${(currentTime / duration) * 100}%` }}
                        ></div>
                        <div
                            className="h-full bg-[transparent] w-full absolute top-0 left-0"
                            onClick={(event: any) => {
                                audioRef.current.currentTime = (event.nativeEvent.offsetX / event.target.clientWidth) * duration;
                            }}
                        ></div>
                    </div>
                </div>

                <div className={` flex justify-end items-center rounded-3xl hover:bg-[#e0e0e0] w-[2.5rem] lg:hover:w-32 width-transition ease-in-out duration-500 gap-[1rem] py-[0.3rem] px-[0.5rem]  `}
                    onMouseEnter={() => {
                        setShowVolumeSlider(true);
                    }} onMouseLeave={() => {
                        setShowVolumeSlider(false)
                    }}
                >
                    {showVolumeSlider && <div className={` w-24 relative bottom-[0.2rem] hidden lg:block `} >
                        <Slider value={volume} onChange={handleVolumeChange} min={0} max={1} step={0.01} sx={{ color: `${isPlaying ? '#EE9322' : '#757575'}` }} className='p-0' />
                    </div>}

                    {duration ? <div onClick={handleMuteBotton} >
                        {volume ? <VolumeUpIcon sx={{ color: `${isPlaying ? '#EE9322' : '#000000'}` }} /> : <VolumeOffIcon sx={{ color: `${isPlaying ? '#EE9322' : '#757575'}` }} />}

                    </div> : <Skeleton variant='circular' height={'40px'} width={'40px'} animation="wave"></Skeleton>}


                </div>

            </div>
        </>
    );
};

export default AudioPlayer;
